/**
 * @module ol/style/IconAnchorUnits
 */
/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
export default {
    FRACTION: 'fraction',
    PIXELS: 'pixels'
};
//# sourceMappingURL=IconAnchorUnits.js.map


// WEBPACK FOOTER //
// ./~/ol/style/IconAnchorUnits.js